
import { Vue } from 'vue-class-component';


  export default class TheFooterTop extends Vue {
  }
